// ** Initial State
const initialState = {
  data: {},
};

const newletterLogoView = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_NEWSLETTER_LOGO_VIEW_REQUEST':
      return { loading: true, error: '', data: {} };
    case 'GET_NEWSLETTER_LOGO_VIEW':
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    default:
      return { ...state };
  }
};

export default newletterLogoView;
